import { _GetCompatibleTextureLoader } from "core/Materials/Textures/Loaders/textureLoaderManager";
import { AbstractEngine } from "../abstractEngine";

AbstractEngine.GetCompatibleTextureLoader = _GetCompatibleTextureLoader;
